import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper';
import { getDisplayMode } from '../common/libs.js';
const setGallerySlider = () => {
  const slider = document.querySelector('.js-opencampus-gallery-slider');
  if (!slider) return false;
  const slides = slider?.querySelectorAll(".swiper-slide");
  const slideLength = slides.length;
  let windowWidth = slider?.clientWidth;
  const slideSize = [...(slides || [])].reduce(
    (sum, slide) => sum + slide.offsetWidth,
    0
  );
  let slideSpace = 0;
  if (getDisplayMode() == 1) {
    slideSpace = 95;
  } else {
    slideSpace = 50;
  }
  let viewSlideLength = Math.floor(windowWidth / (slideSize + slideSpace));

  if (windowWidth < (slideSize + (slideSpace * (slideLength - 1)))) {
    var swiper = new Swiper(slider, {
      modules: [Navigation, Pagination],
      centeredSlides: true,
      speed: 500,
      loop: true,
      slidesPerView: 'auto',
      spaceBetween: slideSpace,
      navigation: {
        nextEl: slider.querySelector('.gallery-slider-button.next'),
        prevEl: slider.querySelector('.gallery-slider-button.prev'),
      },
      pagination: {
        el: document.querySelector('.gallery-slider-pagination')
      }
    });
  } else {
    slider?.classList.add('slide-none');
  }

  slider.classList.add('is-init');
}

export default setGallerySlider;